module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-2.e89ebe2c.png";